import get from 'lodash.get';
import orderBy from 'lodash.orderby';

import { EntityDropdownOptions } from 'scenes/Fertilizer/scenes/Diary/components/FertilizerEventFinalForm/components/FertilizerEventForm/components/FertilizerEventAreaPage/components/FertilizerSchemaInnerEntityTableField/types';

import { getEntityVarietyId } from 'services/entities/utils';

import { EntitiesKeyedByUuid, EntityId } from 'services/entities/types';
import { FertilizerEventJob } from 'services/fertilizerEvents/types';
import { SprayEventJob } from 'services/sprayEvents/types';
import { VarietiesState } from 'services/varieties/types';

// Sorts job type to put "INSPECTION" as the first element of the array. (Necessary as some parts of the code are accessing assignedUsers as jobs[0].assignedUsers)
export const sortEventJobByJobTypes = (
    jobs: FertilizerEventJob[] | SprayEventJob[]
): FertilizerEventJob[] | SprayEventJob[] =>
    jobs.sort((a: FertilizerEventJob, b: FertilizerEventJob) =>
        a.jobType.localeCompare(b.jobType)
    );

export const getEntitiesOptionsWithVariety = (
    options: EntityDropdownOptions,
    entities: EntitiesKeyedByUuid,
    varieties: VarietiesState,
    eventEntityId: EntityId,
    harvestEntityTypeId: any
) => {
    const eventEntityPathnames = get(entities, [eventEntityId, 'pathNames']);

    // Gets the options and attach varietyName into each one based on the harvest schema entity type variety.
    // Then sorts the options by the variety name.
    const denormalizedOptions = options.map((option) => {
        const { value, text } = option;

        // Format option text to avoid displaying the spray/fertiliser entity path ("GR1 / SECTOR 1 / LOT 1 / BLOCK" becomes "LOT 1 / BLOCK")
        const formattedText = text.replace(`${eventEntityPathnames} / `, '');
        const entityName = get(entities, [value, 'name']);
        const varietyId = getEntityVarietyId(
            value,
            entities,
            harvestEntityTypeId
        );

        return {
            ...option,
            varietyName: varietyId
                ? get(varieties, [varietyId, 'name'], 'None')
                : 'None',
            entityName: entityName.padStart(10),
            text: formattedText
        };
    });

    return orderBy(
        denormalizedOptions,
        ['varietyName', 'entityName'],
        ['asc', 'asc']
    );
};
